import React, { useEffect } from "react"

const Imbox = () => {
  useEffect(() => {
    const script = document.createElement("script")
    script.innerHTML = `var _sid = '2998';
          (function() {
          var se = document.createElement('script'); se.type = 'text/javascript'; se.async = true;
          se.src = 'https://files.imbox.io/app/dist/initWidget.js';
          var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(se, s);
          })();`
    script.async = true
    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [])
  return <></>
}
export default Imbox
